import UniversalLink from "components/UniversalLink"
import { ReactComponent as ArrowSVG } from "images/global/buttonArrow.svg"
import { fresponsive } from "library/fullyResponsive"
import { ReactNode } from "react"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import media from "styles/media"
import text from "styles/text"

export default function Link({
  children,
  className,
  to,
}: {
  children: ReactNode
  className: string
  to: string
}) {
  return (
    <Wrapper className={className} to={to}>
      <Arrow />
      {children}
    </Wrapper>
  )
}

const Arrow = styled(ArrowSVG)`
  position: relative;
  height: auto;
  transition:
    transform 0.2s,
    background 0.2s;

  path {
    fill: ${colors.primaryWhite};
    transition: fill 0.2s;
  }

  ${fresponsive(css`
    width: 16px;
    top: -1.5px;
    padding: 3px;
    border-radius: 50%;
  `)}
`

const Wrapper = styled(UniversalLink)`
  width: fit-content;
  display: flex;
  align-items: center;
  ${text.title4}
  color: ${colors.primaryWhite};
  height: 100%;

  ${media.hover} {
    &:hover {
      ${Arrow} {
        transform: rotate(-45deg);
        background: ${colors.primaryYellow};

        path {
          fill: ${colors.primaryBlack};
        }
      }
    }
  }

  ${fresponsive(css`
    gap: 7.5px;
  `)}
`
